import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {JackpotBetPrizeAmountContainerDefaultBox} from "./jp-bet-prize-amount.default.box";
import {JackpotBetPrizeAmountContainerMRGBox} from "./jp-bet-prize-amount.mrg.box";
import {JackpotBetPrizeAmountContainer777Box} from "./jp-bet-prize-amount.777.box";



export const JackpotBetPrizeAmountContainerBox = styledByTheme(JackpotBetPrizeAmountContainerDefaultBox)
    .forMrGreen(JackpotBetPrizeAmountContainerMRGBox)
    .forCasino777(JackpotBetPrizeAmountContainer777Box)
    .apply();


